var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.5 8L7.5 21H16.5L18.5 8","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M3 8H21","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M16.5 8C16.5 5.23858 14.7614 3 12 3C9.23858 3 7.5 5.23858 7.5 8","stroke":"currentColor","strokeWidth":"2","key":2})]);
}

Delete.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Delete;

Delete.default = Delete;
